export default __webpack_public_path__ + "static/media/gallery_09.f83e63e3.jpg";